/**
 * A utility class for managing and performing cleanup operations on objects
 * within the `experience` object when the page is about to unload.
 * @category Experience
 * @subcategory Utils
 */
export default class CleanupInspector {
  /**
   * Constructs a `CleanupInspector` instance and attaches a `beforeunload` event listener.
   * @param {Object} experience - The experience object containing various resources to be cleaned up.
   */
  constructor(experience) {
    this.experience = experience;

    // Attach the beforeunload event to trigger object cleanup
    window.addEventListener("beforeunload", (event) => {
      this.cleanUpObjects(); // Call your cleanup function
    });
  }

  cleanup() {
    console.log("Starting cleanup process...");
    this.cleanUpObjects();
    console.log("Cleanup process completed.");
}

  /**
   * Iterates through all properties of the `experience` object and performs cleanup by calling
   * their `dispose` or `destroy` methods, if they exist.
   */
  cleanUpObjects() {
    // Loop through all properties in the experience object and destroy/dispose if possible
    Object.keys(this.experience).forEach((key) => {
      const obj = this.experience[key];

      // If the object has a dispose or destroy method, call it
      if (obj && typeof obj.dispose === "function") {
        obj.dispose();
      } else if (obj && typeof obj.destroy === "function") {
        obj.destroy();
      }
    });
  }
}
